<info-message-notifier *ngIf="basicDataLoaded"></info-message-notifier>

<dev-component *ngIf="basicDataLoaded"></dev-component>
<reload-detector
  [fileName]="'assets/appVersion.json'"
  [checkTime]="40000"></reload-detector>
<div class="loaded-icon-container">
  <custom-loader
    *ngIf="loadingPage.loading"
    [overParent]="true"
    [iconSize]="'9em'">
  </custom-loader>

  <ng-container *ngIf="loadingPage.loaded">
    <router-outlet *ngIf="basicDataLoaded">
      <div
        class="pull-right server"
        style="position: relative; z-index: 99999; padding-right: 40px"
        *ngIf="!urlNow(window.location.href) && false">
        <button class="btn btn-warning" (click)="stopServers()">
          <i
            class="fa {{
              loadingStopServers ? 'fa-spin fa-spinner' : 'fa-warning'
            }}"></i>
          {{ loadingStopServers ? 'Cancelar' : 'Reiniciar servidores' }}
        </button>
      </div>

      <div *ngIf="window && !urlNow(window.location.href)">
        <panel-service-selector styleType="style2"></panel-service-selector>
      </div>

      <country-selection
        #oldCountrySelector
        [hidden]="true"
        *ngIf="
          !urlNow(window.location.href) && isValidSession
        "></country-selection>
    </router-outlet>
  </ng-container>
</div>
